export const createReferenceValue = (
  sourceField: Record<string, string>,
): Record<string, string> => {
  if (!sourceField?.type)
    throw new Error(`sourceField must contain a 'type' property`);
  if (!sourceField?.fieldTarget)
    throw new Error(`sourceField must contain a 'fieldTarget' property`);

  return {
    fieldTarget: sourceField?.fieldTarget,
    fieldType: sourceField?.type,
    source: sourceField?.source,
    type: 'reference',
    value: sourceField?.fieldName,
  };
};
